import { UIGameSpriteHandler } from '../UIGameSpriteHandler.ts';
import { socket } from '../EntryShared.ts';
import { MatchmakingAction, PRIMARY_MATCHMAKING_ACTIONS } from '@colonist/lobby-types';
import { ClientMessageSubType } from '@colonist/types';
export class SocketMatchmakingSend {
    static send(action, data) {
        const actionDataToSend = {
            action: action,
            payload: data
        };
        socket.controller.sender.sendToServerType(ClientMessageSubType.MatchmakingAction, 'lobby', actionDataToSend, PRIMARY_MATCHMAKING_ACTIONS.includes(action));
    }
    static sendFindGame() {
        if (!this.lastMatchmakingRequest) return;
        this.send(MatchmakingAction.ClickedFindGame, this.lastMatchmakingRequest);
    }
    static enterMatchmaker(matchmakingRequest, shouldDelay = true) {
        this.lastMatchmakingRequest = matchmakingRequest;
        this.clearDelayMatchmakingTimeout();
        if (shouldDelay) {
            this.delayMatchmakingTimeout = setTimeout(()=>{
                void UIGameSpriteHandler.continueAfterAssetsLoad(()=>{
                    this.sendFindGame();
                });
            }, this.matchmakingRequestDelayMs);
            return;
        }
        void UIGameSpriteHandler.continueAfterAssetsLoad(()=>{
            this.sendFindGame();
        });
    }
    static storeMatchmakingRequest(matchmakingRequest) {
        this.lastMatchmakingRequest = matchmakingRequest;
        this.clearDelayMatchmakingTimeout();
    }
    static sendCancelFindGame() {
        this.lastMatchmakingRequest = undefined;
        this.clearDelayMatchmakingTimeout();
        this.send(MatchmakingAction.ClickedCancelFindGame, undefined);
    }
    static clearDelayMatchmakingTimeout() {
        clearTimeout(this.delayMatchmakingTimeout);
        this.delayMatchmakingTimeout = undefined;
    }
}
SocketMatchmakingSend.matchmakingRequestDelayMs = 1000;
